export const websiteBaseURL = "";
export const whatsappNumber = "9657867002";
export const emailId = "shlokzanwar14@gmail.com";

export const githubLink = "https://github.com/Shlok-Zanwar";
export const linkedinLink = "https://www.linkedin.com/in/shlok-zanwar-0124961ba/";
export const hackerrankLink = "https://www.hackerrank.com/shlok_21910163";
export const codechefLink = "https://www.codechef.com/users/shlok_zanwar";
export const instagramLink = "https://www.instagram.com/shlok__zanwar/";
export const twitterLink = "https://www.twitter.com/zanwar_shlok/";


export const coderoomsAboutUsURL = "https://code-rooms.github.io/#/about_us";
export const coderoomsGithubURL = "https://github.com/Code-rooms";

export const dockFormsBlogURL = `${websiteBaseURL}/blogs/dock-forms`;
export const dockFormsGithubURL = "https://github.com/Shlok-Zanwar/Dock-Forms";

export const mathsyraFrontendURL = "https://github.com/Shlok-Zanwar/Mathsyra-Client";
export const mathsyraBackendURL = "https://github.com/Shlok-Zanwar/Mathsyra-Server";

export const hotelManagementBlogURL = `${websiteBaseURL}/blogs/hotel-management`;
export const hotelManagementGithubURL = "https://github.com/Shlok-Zanwar/Hotel-Management-Terminal";

export const todoAppAppURL = `${websiteBaseURL}/apps/todo-app`;
export const todoAppBlogURL = `${websiteBaseURL}/blogs/todo-app`;
export const todoAppGithubURL = "https://github.com/Shlok-Zanwar/Shlok-Zanwar.github.io/tree/main/src/TodoApp";

export const mnistGithubURL = "https://github.com/Shlok-Zanwar/mnist-detection";

export const terminalQuizGithubURL = "https://github.com/Shlok-Zanwar/Terminal-Quiz";

export const pastebinURL = `${websiteBaseURL}/apps/pastebin`;
export const drawbinURL = `${websiteBaseURL}/apps/drawbin`;
export const pastebinGithubURL = "https://github.com/Shlok-Zanwar/Pastebin-React";


export const binaryTreeGithubURL = "https://github.com/Shlok-Zanwar/Binary-Tree-Visualization";
export const heapVisulizationURL = `${websiteBaseURL}/apps/max-heap-visualization`;
export const bstVisulizationURL = `${websiteBaseURL}/apps/bst-visualization`;

export const globalSearchGithubURL = "https://github.com/Shlok-Zanwar/react-global-search";
export const globalSearchNPMURL = "https://www.npmjs.com/package/react-global-search";

export const expenseTrackerGithubURL = "https://github.com/Shlok-Zanwar/Shlok-Zanwar.github.io/tree/main/src/ExpenseTracker"
export const expenseTrackerURL = `${websiteBaseURL}/apps/expense-tracker`;
